module.exports = __webpack_public_path__ + "static/media/teacher-default-image.c91cf3a5.webp";